<table mat-table matSort [dataSource]="medicineDosagePackageTypes" class="medicine-dosage-package-type-list">

    <ng-container matColumnDef="label_name">
        <th mat-header-cell *matHeaderCellDef>Label name</th>
        <td mat-cell *matCellDef="let medicineDosagePackageType"> {{medicineDosagePackageType.label_name ? medicineDosagePackageType.label_name : "-"}} </td>
    </ng-container>

    <ng-container matColumnDef="type">
        <th mat-header-cell *matHeaderCellDef>Type</th>
        <td mat-cell *matCellDef="let medicineDosagePackageType"> {{medicineDosagePackageType.package_type.type}} </td>
    </ng-container>

    <ng-container matColumnDef="quantity">
        <th mat-header-cell *matHeaderCellDef>Quantity</th>
        <td mat-cell *matCellDef="let medicineDosagePackageType"> {{ medicineDosagePackageType.contained_quantity}} {{ dosageUnit ? dosageUnit.unit : ""}}</td>
    </ng-container>

    <ng-container matColumnDef="price">
        <th mat-header-cell *matHeaderCellDef>Price</th>
        <td mat-cell *matCellDef="let  medicineDosagePackageType"> {{ medicineDosagePackageType.price }} </td>
    </ng-container>

    <ng-container matColumnDef="created">
        <th mat-header-cell *matHeaderCellDef>Created</th>
        <td mat-cell *matCellDef="let medicineDosagePackageType"> {{ getCreationTime(medicineDosagePackageType) }}</td>
    </ng-container>

    <ng-container matColumnDef="actions">
        <th mat-header-cell *matHeaderCellDef>&nbsp;</th>
        <td mat-cell *matCellDef="let medicineDosagePackageType">
            <button *authGroup="['SuperAdmin']" class="me-2" (click)="edit(medicineDosagePackageType)" mat-stroked-button>
                <mat-icon>edit</mat-icon> Edit
            </button>

            <button *authGroup="['SuperAdmin']" mat-flat-button color="warn" (click)="delete(medicineDosagePackageType)" class="me-2">
                Delete 
            </button>
        </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
</table>

<mat-paginator
    [length]="total"
    [pageSize]="limit"
    [pageIndex]="page - 1"
    [pageSizeOptions]="[5, 10, 20, 50]"
    (page)="onPageChange($event)">
</mat-paginator>

<div class="d-flex align-items-center justify-content-between mt-2">
    <div>
        <button mat-stroked-button (click)="prevPage()" [disabled]="page <= 1">
            <mat-icon>chevron_left</mat-icon>
            Previous
        </button>
        <button class="ms-2" mat-stroked-button (click)="nextPage()" [disabled]="(page * limit) >= total">
            Next
            <mat-icon>chevron_right</mat-icon>
        </button>
    </div>
    <div>
        Page {{page}} of {{ lastPage }}
    </div>
  </div>